import styled from 'styled-components';

export const StyledSocialIcons = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	a {
		border: 1px solid #fff;
		border-radius: 50%;
		color: #fff;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		margin-right: 10px;
		height: 40px;
		width: 40px;
		text-decoration: none;

		&:hover {
			opacity: 0.9;
			color: ${({ theme }) => theme.colors.header};
			transform: scale(0.98);
		}
	}

	ul {
		list-style-type: none;
		position: relative;
	}

	li {
		list-style-type: none;
	}
`;
